import { Button, Card } from '@expressable/syntax-ds';
import { ContentfulTherapistSummary } from 'components/ContentfulTherapistCard/ContentfulTherapistSummary';
import { SmallTherapist } from 'domains/calendars/types';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { StateAbbrev } from 'utils/states';

type Props = {
  therapists?: SmallTherapist[];
  state?: StateAbbrev;
  clinicalAreas: string[];
  insuranceName?: string;
  onConfirm: (calendarId: string) => void;
};

export const TherapistList: FC<Props> = ({ therapists, state, clinicalAreas, insuranceName, onConfirm }) => {
  const { t } = useTranslation();

  if (!therapists || !state) {
    return null;
  }

  return (
    <div className="flex flex-col gap-e40 w-full">
      {therapists.map(therapist => (
        <Card key={therapist.acuityCalendarID}>
          <ContentfulTherapistSummary
            therapistName={`${therapist.firstName} ${therapist.lastName}`}
            stateCode={state}
            clinicalAreas={clinicalAreas}
            insuranceName={insuranceName}
            shouldShowProfile={true}
            cta={
              <Button
                onClick={() => onConfirm(therapist.acuityCalendarID)}
                variant="primary"
                size="lg"
              >
                {t('rescheduleDirect.selectTherapist.selectTherapistCta')}
              </Button>
            }
          />
        </Card>
      ))}
    </div>
  );
};

